/**
 * Which pane owns a thread, decided from its metadata alone.
 *
 * Three panes can own one:
 *   'internal' — staff Chats     (metadata.internal / metadata.internalKind)
 *   'direct'   — Private         (metadata.conversationType === "app_direct")
 *   'normal'   — patient Messages (everything else, including "app" and "whatsapp")
 *
 * The 'direct' branch is the one that is easy to get wrong, and did: a private contact chat
 * carries NEITHER `internal` nor `internalKind` — deliberately, because that is what keeps it out
 * of the staff Chats list — so a check that only looked for those fell through to 'normal', and a
 * notification click opened somebody's private conversation inside the shared patient inbox.
 *
 * Note how close "app" and "app_direct" are: one is the shared care-team conversation the whole
 * channel team reads, the other is private to two people. A prefix match here would be a leak.
 */
export function scopeForThreadMetadata(metadata) {
  if (metadata && (metadata.internal === true || metadata.internalKind)) return 'internal';
  if (String(metadata?.conversationType || '').toLowerCase() === 'app_direct') return 'direct';
  return 'normal';
}
